
'use strict';//Indicating browser should run only in java script mode
//http://stackoverflow.com/questions/20369377/how-to-use-http-get-in-angularjs-correctly-in-specific-for-an-external-api-cal

//*******PURPOSE: The purpose of the service is to handle each and every http wcf calls related to ehr chat messages functionality
//*******CREATED BY: A. G. K
//*******CREATED DATE: 12/29/2016
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

angular.module('EMR.EHRChatMessages').service('EHRChatApplicationService', ['CommonService', 'CommonPostService', '$injector', function (CommonService, CommonPostService, $injector) {


    //################### INSERT EHR CHAT USERS MESSAGES BLOCK START #########################


    this.ChatInsertChatUserMessages = function (postdata) {

        postdata.practicemodel = EMRPracticeModel;
        postdata.IsFromEHRWeb = true;

        return CommonService.PostData('POST', CommonService.EHR_ChatApplication_API() + "InsertChatUserMessages", postdata).then(function (result) {
            return result;
        });
    };


	this.InsertChatMultipleUserMessages = function (postdata) {

		postdata.practicemodel = EMRPracticeModel;
		postdata.IsFromEHRWeb = true;

		return CommonService.PostData('POST', CommonService.EHR_ChatApplication_API() + "InsertChatMultipleUserMessages", postdata).then(function (result) {
			return result;
		});
	};

    //################### INSERT EHR CHAT USERS MESSAGES BLOCK END #########################

    //################### GET EHR CHAT USERS MESSAGES LIST BLOCK START #########################


    this.getEHRChatUsersMessagesList = function (postdata) {

        postdata.practicemodel = EMRPracticeModel;
        postdata.IsFromEHRWeb = true;

        return CommonService.PostData('POST', CommonService.EHR_ChatApplication_API() + "GetChatUserMessagesList", postdata).then(function (result) {
            return result;
        });
    };

    //################### GET EHR CHAT USERS MESSAGES LIST BLOCK END #########################


    //################### GET EHR CHAT USERS MESSAGES ATTACHMENT BLOCK START #########################


    this.getEHRChatUsersMessagesAttachment = function (postdata) {

        postdata.practicemodel = EMRPracticeModel;

        return CommonService.PostData('POST', CommonService.EHR_ChatApplication_API() + "GetChatUserAttachmentBinary", postdata).then(function (result) {
            return result;
        });
    };

    //################### GET EHR CHAT USERS MESSAGES ATTACHMENT BLOCK END #########################

    //################### GET EHR CHAT USERS MESSAGES ATTACHMENT URL BLOCK START #########################


    this.getEHRChatUsersMessagesAttachmentURL = function (postdata) {

        postdata.practicemodel = EMRPracticeModel;
        postdata.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

        return CommonService.PostData('POST', CommonService.EHR_ChatApplication_API() + "GetChatUserAttachmentPDFURL", postdata).then(function (result) {
            return result;
        });
    };

    //################### GET EHR CHAT USERS MESSAGES ATTACHMENT URL BLOCK END #########################

    //################### GET EHR CHAT USERS RECIPIENTS LIST BLOCK START #########################


    this.getEHRChatUsersRecipientsList = function (postdata) {

        postdata.practicemodel = EMRPracticeModel;

        return CommonService.PostData('POST', CommonService.EHR_ChatApplication_API() + "GetChatUserRecipientsList", postdata).then(function (result) {
            return result;
        });
    };

    //################### GET EHR CHAT USERS MESSAGES LIST BLOCK END #########################

    //################### GET EHR CHAT USERS MESSAGES LIST BLOCK START #########################


    this.getEHRChatUserMessagesHistory = function (postdata) {

        postdata.practicemodel = EMRPracticeModel;
        postdata.IsFromEHRWeb = true;

        return CommonService.PostData('POST', CommonService.EHR_ChatApplication_API() + "GetChatUserMessagesHistory", postdata).then(function (result) {
            return result;
        });
    };

    //################### GET EHR CHAT USERS MESSAGES LIST BLOCK END #########################


    //################### GET EHR CHAT USERS MESSAGES LIST BLOCK START #########################


    this.EHRChatGetTemplatesWithUsersHavePermissionToChatApplicationInPortal = function (postdata) {

        postdata.practicemodel = EMRPracticeModel;


        return CommonService.PostData('POST', CommonService.EHR_ChatApplication_API() + "GetTemplatesWithUsersHavePermissionToChatApplicationInPortal", postdata).then(function (result) {
            return result;
        });
    };

    //################### GET EHR CHAT USERS MESSAGES LIST BLOCK END #########################



    //################### GET EHR CHAT USERS MESSAGES LIST BLOCK START #########################


    this.EHRChatChangeChatUserMessagesStatus = function (postdata) {

        postdata.practicemodel = EMRPracticeModel;
        return CommonService.PostData('POST', CommonService.EHR_ChatApplication_API() + "ChangeChatUserMessagesStatus", postdata).then(function (result) {
            return result;
        });

    };

    //################### GET EHR CHAT USERS MESSAGES LIST BLOCK END #########################

    //#################### METHOD TO GET ZOOM ACTIVE MEETING INFO (URL Based) BLOCK START ######################
    //*******PURPOSE: THIS METHOD TO GET ZOOM ACTIVE MEETINGS INFO
    ///*******CREATED BY:SATYA.D
    ///*******CREATED DATE:12/2/2019
    ///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    this.ehrZoomGetZoomActiveMeetingInfoURLBased = function (postData) {

        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
        return CommonService.PostData('POST', CommonService.EHR_ZoomMeeting() + "ZoomActiveMeetingInfoURLBased", postData).then(
            function (result) {
                return result;
            });
    };
    //#################### METHOD TO GET ZOOM ACTIVE MEETINGS INFO (URL Based)  BLOCK ENDS ######################

    //#################### METHOD TO CLOSE CURRENT MEETING AND CREATE NEW MEETING (URL BASED) BLOCK START ######################
    //*******PURPOSE: THIS METHOD TO CLOSE CURRENT MEETING AND CREATE NEW MEETING
    ///*******CREATED BY:SATYA.D
    ///*******CREATED DATE:12/3/2019
    ///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    this.ehrZoomCloseCurrentMeetingCreateNewMeetingURLBased = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonService.PostData('POST', CommonService.EHR_ZoomMeeting() + "ZoomCloseCurrentMeetingCreateNewMeetingURLBased", postData).then(
            function (result) {
                return result;
            });
    };
    //#################### METHOD TO CLOSE CURRENT MEETING AND CREATE NEW MEETING (URL BASED) BLOCK ENDS ######################

    //#################### METHOD TO GET ZOOM ACTIVE MEETINGS LIST BLOCK START ######################
    //*******PURPOSE: THIS METHOD TO GET ZOOM ACTIVE MEETINGS LIST
    ///*******CREATED BY:SATYA.D
    ///*******CREATED DATE:12/2/2019
    ///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    this.ehrZoomGetZoomActiveMeetingsList = function (postData) {

        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;

        return CommonService.PostData('POST', CommonService.EHR_ZoomMeeting() + "ZoomActiveMeetingsList", postData).then(
            function (result) {
                return result;
            });
    };
    //#################### METHOD TO GET ZOOM ACTIVE MEETINGS LIST BLOCK ENDS ######################

    //#################### METHOD TO CLOSE CURRENT MEETING AND CREATE NEW MEETING BLOCK START ######################
    //*******PURPOSE: THIS METHOD TO CLOSE CURRENT MEETING AND CREATE NEW MEETING
    ///*******CREATED BY:SATYA.D
    ///*******CREATED DATE:12/3/2019
    ///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    this.ehrZoomCloseCurrentMeetingCreateNewMeeting = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonService.PostData('POST', CommonService.EHR_ZoomMeeting() + "ZoomCloseCurrentMeetingCreateNewMeeting", postData).then(
            function (result) {
                return result;
            });
    };
    //#################### METHOD TO CLOSE CURRENT MEETING AND CREATE NEW MEETING BLOCK ENDS ######################

    //#################### METHOD TO CREATE NEW  MEETING BLOCK (URL BASED) START ######################
    //*******PURPOSE: THIS METHOD TO CREATE NEW  MEETING BLOCK (URL BASED)
    ///*******CREATED BY:SATYA.D
    ///*******CREATED DATE:12/12/2019
    ///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    this.ehrZoomCreateNewMeetingURLBased = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonService.PostData('POST', CommonService.EHR_ZoomMeeting() + "ZoomCreateNewMeetingURLBased", postData).then(
            function (result) {
                return result;
            });
    };
    //#################### METHOD TO CREATE NEW  MEETING BLOCK (URL BASED) ENDS ######################

    //#################### METHOD TO CLOSE CURRENT MEETING AND CREATE NEW MEETING BLOCK START ######################
    //*******PURPOSE: THIS METHOD TO CLOSE CURRENT MEETING AND CREATE NEW MEETING
    ///*******CREATED BY:SATYA.D
    ///*******CREATED DATE:12/3/2019
    ///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; *************************
    this.ehrZoomCreateNewMeeting = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonService.PostData('POST', CommonService.EHR_ZoomMeeting() + "ZoomCreateNewMeeting", postData).then(
            function (result) {
                return result;
            });
    };
    //#################### METHOD TO CLOSE CURRENT MEETING AND CREATE NEW MEETING BLOCK ENDS ######################

    this.FileUploadHandlerNewService = function(){
        return `${emrHandleGatewayUrlForASHXFileFromatChanges(CommonPostService.EHR_ChatApplication_API_FileUploadNew())}FileUploadHandlerNew.ashx`;
    }
    
    
    
    this.MultipleFileUploadHandlerNew = function(){
        return `${emrHandleGatewayUrlForASHXFileFromatChanges(CommonPostService.EHR_ChatApplication_Multiple_API())}MultipleFileUploadHandlerNew.ashx`;
    }

    this.changeGateWayUrl = function (postData, gatewayUploadUrl) {
        try {
            gatewayUploadUrl = $injector.get('EmrHttpService').getNextUrl(gatewayUploadUrl);
        } catch (e) {
            console.error(e);
            console.error("EmrHttpService is not available, please check the service registration.");
        }
        if (gatewayUploadUrl && gatewayUploadUrl.toLowerCase().indexOf("gateway") > -1) {//removing dbserver name if url has gateway Appended
            delete postData.fields.DBServerName;
            postData.headers = GetEhRAuthorizationHeaderToSend();
        }
        postData.url = gatewayUploadUrl;
        return postData;
    }

    function GetEhRAuthorizationHeaderToSend() {
        let LoggedUserID = angular.copy(EMRPracticeModel.LoggedUserID);
        if (EMRPracticeModel.ApplicationType && EMRPracticeModel.ApplicationType == 2 && EMRPracticeModel.PortalUserType) {
            LoggedUserID = `${EMRPracticeModel.LoggedUserID}-${EMRPracticeModel.PortalUserType}`;
        }
        return {
            "Authorization": "Bearer " + CommonPostService.getJWTAccesToken(),
            "PracticeID": EMRPracticeModel.PracticeID,
            "LoggedUserID": LoggedUserID,
            "LoggedUserType": EMRPracticeModel.UserType,
            "EHRWebSiteApplicationType": (EMRPracticeModel.isEmergencyWeb ? 4 : EMRPracticeModel.ApplicationType),
            "CorrelationId": CommonPostService.buildCorrelationId()
        }
    }

    this.GetPracticeSecuritySettingsInfo = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
        return CommonService.PostData('POST', CommonService.EHR_Practice_Settings_API() + "GetPracticeSecuritySettingsInfo", postData).then(function (result) { return result; });
    };
    this.getGroupChatsInfoList = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_Group_Chat_Application_API_Net8() + "GetGroupChatsInfoList", postData)
    };
    this.deleteGroupChatInfo = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_Group_Chat_Application_API_Net8() + "DeleteGroupChatInfo", postData)
    };
    this.getGroupChatUsersInfoList = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_Group_Chat_Application_API_Net8() + "GetGroupChatUsersInfoList", postData)
    };
    this.getGroupChatUserMessagesHistory = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_ChatApplication_API() + "GetGroupChatUserMessagesHistory", postData)
    };
    this.deleteGroupChatMessagesForAllUsers = function (postData) {
        postData.practicemodel = EMRPracticeModel;
        postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
        return CommonPostService.httpPostData('POST', CommonPostService.EHR_ChatApplication_API() + "DeleteGroupChatMessagesForAllUsers", postData)
    };
}]);
